import { Dialog as MDialog, styled } from '@mui/material';

export const Dialog = styled(MDialog, {
  shouldForwardProp: (prop) => prop !== 'mobileApp',
})<{ mobileApp: boolean }>(({ mobileApp }) => ({
  '& .MuiPaper-root': {
    padding: mobileApp ? '8px 8px 0' : '26px 32px 0 32px',
    borderRadius: '8px',
  },
}));

export const Header = styled('div')(() => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  '& > div': {
    display: 'flex',
    alignItems: 'center',
    gap: '6px',
  },
}));

export const Content = styled('div', {
  shouldForwardProp: (prop) => prop !== 'mobileApp',
})<{ mobileApp: boolean }>(({ mobileApp }) => ({
  margin: mobileApp ? 0 : '20px 10px',
}));

export const Footer = styled('div')(() => ({
  display: 'flex',
  justifyContent: 'flex-end',
  gap: '8px',
  padding: '16px 0',
}));
